/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MediaEventType {
    Play = 0,
    Stop = 1,
    Forward = 10,
    Backward = 11,
    Looping = 20,
}
